import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function resourceByServiceReportReducer(
  state: ReportDto = initialState.resourceByServiceReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_RESOURCE_BY_SERVICE_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
